// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "artifacts/js/" + chunkId + "." + {"151":"8f3b999987b2f5799e19","554":"c74920467182a065f323"}[chunkId] + ".chunk.js";
};